


import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {AiOutlineMinus} from "react-icons/ai" 
import { IoIosArrowDown } from "react-icons/io"
import { handleActiveSelect } from "../../../../../../features/layout/layoutSlice"
import halfTime from "../../../../../../utils/halfTime"
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice"

const Container = styled.div`
    width: 200px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 5px;

    .input-wrapper{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        input{
            width: calc(50% - 3px);
            height: 100%;
            padding: 10px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            border-radius: ${({radius}) => radius};
            color: ${({ theme }) => theme.mainTextColor};
            background-color: ${({theme}) => theme.mainBgColor};
            text-align: center;
        }


        .input1{
            padding-right: 0;
        }

        .input2{
            padding-left: 0;
        }

        label{
            position: absolute;
            transform: ${({isMoved}) => isMoved && "translateY(-22px)"};
            bottom: 12px;
            left: 20px;
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            pointer-events: none;
            transition:  all .3s ease;
            z-index: 5;
            color: ${({theme, isMoved}) => isMoved ? theme.mainTextColor : theme.secondaryTextColor};
            background-color: ${({theme}) => theme.mainBgColor};
        }

        .seperator{
            pointer-events: none;
        }

        .arr-icon{
            transition: .2s;
            font-size: 1.2rem;
            transform: ${({isOptionsOpened}) => (!isOptionsOpened ? `rotate(-90deg)` : '')};
            margin-right:5px;
        }

    }


    .options-wrapper{
        width: 100%;
        display: flex;
        position: absolute;
        z-index:20;
        top: 40px;
        max-height: 300px;
        overflow: auto;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        background-color: ${({theme}) => theme.mainBgColor};

        .option-side{
            width: 50%;
            display: flex;
            flex-direction: column;

            .option-item{
                padding: 10px;
                color: ${({ theme }) => theme.mainTextColor};
                text-align: center;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                cursor: pointer;

                &:hover{
                    background-color: ${({theme}) => theme.secondaryBgColor};
                }
            }

            .active{
                color: var(--color-main);
                background-color: ${({theme}) => theme.mainColorTranparent};
            }
        }
    }
    @media (max-width: 1200px){
        width: 150px !important;
    }
`

const BosaltmaTimeRangeInput = ({ data, name, isRequired}) => {
    const [text1, setText1] = useState(data.saatBaslangic)
    const [text2, setText2] = useState(data.saatBitis)

    useEffect(() => {   
        setText1(data.saatBaslangic)
        setText2(data.saatBitis)
    },[data.saatBaslangic, data.saatBitis])

    useEffect(()=> {
        if(data.saatBaslangic && data.saatBitis){
            dispatch(handleActiveSelect(null))
        }
    },[data.saatBaslangic, data.saatBitis])

    const [options1, setOptions1] = useState(halfTime)
    const [options2, setOptions2] = useState(halfTime)

    const [focus1, setFocus1] = useState(false)
    const [focus2, setFocus2] = useState(false)

    const [isError, setIsError] = useState(false)

    const {activeSelect} = useSelector(state => state.layout)

    const dispatch = useDispatch()

    useEffect(()=> {
        setText1(data.saatBaslangic)
        setText2(data.saatBitis)
    },[data.saatBaslangic, data.saatBitis])

    const handleChange1 = (e) => {
        const text = e.target.value

        if(!text){
            setOptions1(halfTime)
        }

        else{
            const filtered = halfTime.filter((item) =>{
                return item.time.toLowerCase().includes(text.toLowerCase())
            }) 
            setOptions1(filtered)
        }

        setText1(e.target.value)
    }

    const handleChange2 = (e) => {
        const text = e.target.value

        if(!text){
            setOptions2(halfTime)
        }

        else{
            const filtered = halfTime.filter((item) =>{
                return item.time.toLowerCase().includes(text.toLowerCase())
            }) 
            setOptions2(filtered)
        }

        setText2(e.target.value)
    }


    const handleSelectClick = () => {
        //! bu seselct le alakalı tıklandığında select varsa ve select === bunun name ine ise sect i kapatıyor yoksa select e bunun name ini atayıp bu select i açtırıyor. 
        dispatch(handleActiveSelect(activeSelect !== name && name))
    }

    const handleOptionClick = (item, type) => {

        if(type === "first"){
            setText1(item.time)
            dispatch(updateRouteItem( {id: data.id, saatBaslangic: item.time}))
        }

        if(type === "second"){
            setText2(item.time)
            dispatch(updateRouteItem( {id: data.id, saatBitis: item.time}))
        }

        //! bu tamamen select le alakalı tıklandığında açık olan select i kapatmak için
        // dispatch(handleActiveSelect(null))

    }

  return (
    <Container radius={"5px"} isMoved={text1 || text2 || focus1 || focus2} onClick={handleSelectClick} isOptionsOpened={activeSelect === name}>
        <div className="input-wrapper">
            <label htmlFor={"text"}>Boşaltma Saat Aralığı</label>
            <input type="text" id={"text"} className="input1" onChange={handleChange1} onFocus={() => setFocus1(true)} onBlur={() => setFocus1(false)} value={text1} name={"text"} autoComplete="off"/> 
            {
                (focus1 || focus2) &&
                <div className="seperator" onFocus={() => setFocus1(true)} onBlur={() => setFocus1(false)}> - </div>
            }
            <input type="text" id={"text"} className="input2" onChange={handleChange2} onFocus={() => setFocus2(true)} onBlur={() => setFocus2(false)} value={text2} name={"text"} autoComplete="off" /> 
            <IoIosArrowDown className="arr-icon"/>
        </div>
        {
            (activeSelect === name) &&
            <div className="options-wrapper">
                <div className="option-side">
                    {
                        options1.map((item) => (
                            <div onClick={() => handleOptionClick(item ,"first")} className={item.time === text1 ? " active option-item" : "option-item"}>
                                {item.time}
                            </div>
                        ))
                    }
                </div>

                <div className="option-side">
                    {
                        options2.map((item) => (
                            <div onClick={() => handleOptionClick(item ,"second")} className={item.time === text2 ? " active option-item" : "option-item"}>
                                {item.time}
                            </div>
                        ))
                    }
                </div>
            </div>
        }

        
    </Container>
  )
}

export default BosaltmaTimeRangeInput